<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
        ประเภทข่าว
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        จัดการหมวดหมู่ข่าวประชาสัมพันธ์ และรูปประกอบประเภท
      </p>
    </div>
    <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center self-start">
      <span class="text-xs text-slate-400 whitespace-nowrap self-center">
        ดึงข้อมูลล่าสุด:
        <strong class="text-slate-600 dark:text-slate-300">
          {{ lastFetchedAt() ? (lastFetchedAt() | date:'dd/MM/yyyy HH:mm:ss') : 'ยังไม่ได้ดึงข้อมูล' }}
        </strong>
      </span>
      <button type="button" (click)="onRefresh()" title="ดึงข้อมูล"
        class="px-4 py-3 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer font-bold">
        <span class="material-icons">refresh</span>
        <span>ดึงข้อมูล</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-6 py-3 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-500/20 flex items-center justify-center gap-2 cursor-pointer transition-all">
        <span class="material-icons text-xl">add_circle</span>
        สร้างประเภท
      </button>
    </div>
  </div>

  <div class="bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 overflow-hidden relative">

    <div class="p-6 border-b border-slate-100 dark:border-slate-800 space-y-4">
      <div class="flex items-center gap-2 mb-1">
        <span class="material-icons text-amber-500 text-[20px]">category</span>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">รายการประเภท</h3>
        <span class="ml-auto text-xs font-bold text-slate-400">{{ filteredItems.length | number }} รายการ</span>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        <div class="relative xl:col-span-2">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()"
            placeholder="ค้นหาชื่อ / code..."
            class="w-full pl-10 pr-4 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 placeholder:text-slate-400" />
        </div>

        <div class="relative">
          <select [(ngModel)]="filterActive" (change)="onSearch()"
            class="w-full appearance-none px-4 pr-10 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">สถานะทั้งหมด</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
          <span class="absolute right-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 pointer-events-none">expand_more</span>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[320px] custom-scrollbar">
      <table class="w-full text-left text-sm">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-[11px] font-bold text-slate-400 uppercase tracking-wider">
            <th class="px-5 py-4">Code</th>
            <th class="px-5 py-4">ชื่อ</th>
            <th class="px-5 py-4">Name EN</th>
            <th class="px-5 py-4 text-center">Sort</th>
            <th class="px-5 py-4 text-center">รูป</th>
            <th class="px-5 py-4">สถานะ</th>
            <th class="px-5 py-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredItems"
            class="border-t border-slate-100 dark:border-slate-800 hover:bg-amber-50/40 dark:hover:bg-amber-900/10 transition-colors">
            <td class="px-5 py-4">
              <span class="font-mono text-xs font-bold text-slate-600 dark:text-slate-300">{{ item.code }}</span>
            </td>
            <td class="px-5 py-4 max-w-[240px]">
              <div class="font-bold text-slate-800 dark:text-slate-100 truncate" [title]="item.name">{{ item.name }}</div>
              <div class="text-[11px] text-slate-400 mt-0.5 line-clamp-1">{{ item.description || '—' }}</div>
            </td>
            <td class="px-5 py-4 text-xs font-medium text-slate-600 dark:text-slate-300">
              {{ item.nameEn || '—' }}
            </td>
            <td class="px-5 py-4 text-center tabular-nums text-slate-500">
              {{ item.sortOrder ?? 0 }}
            </td>
            <td class="px-5 py-4 text-center">
              <span class="inline-flex items-center justify-center min-w-8 px-2 py-1 rounded-lg text-[11px] font-bold bg-slate-50 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-100 dark:border-slate-700">
                {{ item.images?.length || 0 }}
              </span>
            </td>
            <td class="px-5 py-4">
              <span class="px-2.5 py-1 rounded-lg text-[11px] font-bold border"
                [ngClass]="item.active
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 border-emerald-200/60'
                  : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400 border-slate-200/60'">
                {{ item.active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="px-5 py-4 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEdit(item)" title="แก้ไข"
                class="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-slate-50 dark:bg-slate-800 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20 border border-slate-100 dark:border-slate-700 transition-colors cursor-pointer">
                <span class="material-icons text-[18px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && filteredItems.length === 0">
            <td colspan="7" class="px-6 py-16 text-center text-slate-400">
              <span class="material-icons text-4xl opacity-40 block mb-2">inbox</span>
              <p class="font-bold">ไม่พบประเภท</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Create / Edit modal -->
<div *ngIf="isModalOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeModal()">
  <div class="relative w-full max-w-2xl max-h-[90vh] overflow-hidden bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700 flex flex-col"
    (click)="$event.stopPropagation()">

    <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-800 shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-2xl bg-amber-400/15 flex items-center justify-center text-amber-500">
          <span class="material-icons">{{ isEdit ? 'edit_note' : 'post_add' }}</span>
        </div>
        <div>
          <h2 class="text-lg font-black text-slate-900 dark:text-white tracking-tight">
            {{ isEdit ? 'แก้ไขประเภทข่าว' : 'สร้างประเภทข่าว' }}
          </h2>
          <p class="text-[11px] text-slate-400 font-medium mt-0.5">
            {{ isEdit ? ('ID: ' + form.id) : 'กรอกข้อมูลประเภทข่าว' }}
          </p>
        </div>
      </div>
      <button type="button" (click)="closeModal()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors cursor-pointer border-none bg-transparent">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar p-6 space-y-5">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            Code <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">tag</span>
            <input type="text" [(ngModel)]="form.code" placeholder="เช่น announcement"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400" />
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            ชื่อ <span class="text-rose-500">*</span>
          </label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">label</span>
            <input type="text" [(ngModel)]="form.name" placeholder="ชื่อประเภทภาษาไทย"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400" />
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Name EN</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">translate</span>
            <input type="text" [(ngModel)]="form.nameEn" placeholder="English name"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400" />
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Sort Order</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">sort</span>
            <input type="number" [(ngModel)]="form.sortOrder"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none" />
          </div>
        </div>

        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Description</label>
          <textarea [(ngModel)]="form.description" rows="2" placeholder="รายละเอียดประเภท"
            class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none placeholder:text-slate-400"></textarea>
        </div>

        <div class="md:col-span-2">
          <label
            class="inline-flex items-center gap-3 px-4 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer select-none hover:border-amber-200 transition-colors">
            <input type="checkbox" [(ngModel)]="form.active"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer" />
            <span class="text-sm font-bold text-slate-700 dark:text-slate-200">Active</span>
          </label>
        </div>
      </div>

      <div *ngIf="isEdit" class="pt-4 border-t border-slate-100 dark:border-slate-800 space-y-4">
        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div class="flex items-center gap-2">
            <span class="material-icons text-amber-500 text-[20px]">photo_library</span>
            <h3 class="text-sm font-bold text-slate-800 dark:text-slate-100">รูปประกอบประเภท</h3>
          </div>
          <label *ngIf="canUpdate"
            class="inline-flex items-center justify-center gap-2 px-4 h-[42px] rounded-xl bg-slate-800 hover:bg-slate-700 text-white text-xs font-bold cursor-pointer transition-colors">
            <span class="material-icons text-[18px]">cloud_upload</span>
            อัปโหลดรูป
            <input type="file" accept="image/*" class="hidden" (change)="onImageSelected($event)" />
          </label>
        </div>

        <div class="grid grid-cols-2 gap-3">
          <div *ngFor="let img of modalImages()"
            class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 overflow-hidden">
            <div class="aspect-video bg-slate-100 dark:bg-slate-800 flex items-center justify-center overflow-hidden">
              <img *ngIf="img.fullPath && !isImageBroken(img.id)" [src]="img.fullPath" [alt]="img.caption || img.imagePath"
                (error)="onImageError(img.id)" class="w-full h-full object-cover" />
              <span *ngIf="!img.fullPath || isImageBroken(img.id)"
                class="material-icons text-3xl text-slate-300 dark:text-slate-600">broken_image</span>
            </div>
            <div class="p-3 space-y-2">
              <p class="text-[10px] font-mono text-slate-400 break-all line-clamp-2" [title]="img.fullPath">
                {{ img.fullPath || img.imagePath || '—' }}
              </p>
              <button *ngIf="canDelete" type="button" (click)="askDeactivateImage(img)"
                class="inline-flex items-center gap-1 text-[11px] font-bold text-rose-500 hover:text-rose-600 cursor-pointer bg-transparent border-none p-0">
                <span class="material-icons text-[14px]">block</span>
                ปิดใช้งาน
              </button>
            </div>
          </div>
          <div *ngIf="modalImages().length === 0"
            class="col-span-full py-8 text-center text-slate-400 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700">
            <span class="material-icons text-3xl opacity-40 block mb-1">image_not_supported</span>
            <p class="text-xs font-medium">ยังไม่มีรูป</p>
          </div>
        </div>
      </div>
      <p *ngIf="!isEdit" class="text-[11px] text-slate-400 font-medium">
        บันทึกประเภทก่อน แล้วจึงอัปโหลดรูปประกอบได้
      </p>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col-reverse sm:flex-row justify-between gap-3 shrink-0">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 bg-transparent">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
        <button type="button" (click)="closeModal()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors cursor-pointer bg-transparent">
          ยกเลิก
        </button>
        <button *ngIf="canCreate || canUpdate" type="button" (click)="onSave()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-bold shadow-lg shadow-amber-500/20 transition-all cursor-pointer border-none flex items-center gap-2">
          <span class="material-icons text-[18px]">save</span>
          บันทึก
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && form.id"
  [entityType]="activityEntityTypes.NewsCategory"
  [entityId]="form.id!"
  title="ประวัติประเภทข่าว"
  [subtitle]="'#' + form.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal
  *ngIf="isConfirmDeactivateOpen"
  title="ยืนยันปิดใช้งานรูป?"
  message="ปิดใช้งานรูปประกอบนี้"
  [highlight]="pendingDeactivateImage?.fullPath || ''"
  messageSuffix=""
  confirmLabel="ปิดใช้งาน"
  cancelLabel="ยกเลิก"
  icon="block"
  variant="danger"
  [showIrreversibleNote]="true"
  (confirm)="confirmDeactivateImage()"
  (cancel)="closeConfirmDeactivate()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading() || isSaving() || isUploading()"></app-pss-loading>
